import Vue from 'vue'
import Router from 'vue-router'
import store from './../store'
import { routerNames } from './../common/js/const'
import * as types from './../store/mutation-types'

// 首页
const login = r => require.ensure([], () => r(require('@/views/index/login.vue')));
const state = r => require.ensure([], () => r(require('@/views/orderInvoice/state.vue')));
// 二维码开票
const OrderInvoiceIssue = r => require.ensure([], () => r(require('@/views/orderInvoice/issue.vue')));
// 发票列表
const OrderInvoices = r => require.ensure([], () => r(require('@/views/orderInvoice/invoices.vue')));
// 发票详情页
const OrderInvoicesOwtDetail = r => require.ensure([], () => r(require('@/views/orderInvoice/owtDetail.vue')));
// 发票影像页
const OrderInvoicesImage = r => require.ensure([], () => r(require('@/views/orderInvoice/invoiceImage.vue')));

// 发票抬头  增删改查,上传抬头
const InvoiceTitleIndex = r => require.ensure([], () => r(require('@/views/invoiceTitle/index.vue')));
const InvoiceTitleCreate = r => require.ensure([], () => r(require('@/views/invoiceTitle/create.vue')));
const InvoiceTitleDetail = r => require.ensure([], () => r(require('@/views/invoiceTitle/detail.vue')));

Vue.use(Router);

const routes = [
  {
    path: '/',
    redirect: '/index/login',
  },
  {
    path: '/index/login',
    name: routerNames.login,
    meta: {
      title: '登录',
      scrollToTop: true,
      keepAlive: true,
      transition: false,
    },
    component: login
  },
  {
    path: '/orderInvoice/issue',
    name: routerNames.OrderInvoiceIssue,
    meta: {
      title: '开具发票',
      scrollToTop: true,
      keepAlive: true,
      transition: false,
    },
    component: OrderInvoiceIssue
  },
  {
    path: '/orderInvoice/invoices',
    name: routerNames.OrderInvoices,
    meta: {
      title: '发票列表',
      scrollToTop: true,
      keepAlive: true,
      transition: false,
    },
    component: OrderInvoices
  },
  {
    path: '/orderInvoice/owtDetail/:id',
    name: routerNames.OrderInvoicesOwtDetail,
    meta: {
      title: '发票详情',
      scrollToTop: true,
      keepAlive: true,
      transition: false,
    },
    component: OrderInvoicesOwtDetail
  },
  {
    path: '/orderInvoice/invoiceImage',
    name: routerNames.OrderInvoicesImage,
    meta: {
      title: '发票内容',
      scrollToTop: true,
      keepAlive: true,
      transition: false,
    },
    component: OrderInvoicesImage
  },
  {
    path: '/invoiceTitle',
    redirect: '/invoiceTitle/index',
  },
  {
    path: '/invoiceTitle/index',
    name: routerNames.InvoiceTitleIndex,
    meta: {
      title: '发票抬头',
      scrollToTop: true,
      keepAlive: true,
      transition: false,
    },
    component: InvoiceTitleIndex
  },
  {
    path: '/invoiceTitle/create',
    name: routerNames.InvoiceTitleCreate,
    meta: {
      title: '新增抬头',
      scrollToTop: true,
      keepAlive: true,
      transition: false,
    },
    component: InvoiceTitleCreate
  },
  {
    path: '/invoiceTitle/detail/:id',
    name: routerNames.InvoiceTitleDetail,
    meta: {
      title: '抬头详情',
      scrollToTop: true,
      keepAlive: true,
      transition: false,
    },
    component: InvoiceTitleDetail
  },
  {
    path: '/orderInvoice/state',
    name: routerNames.state,
    meta: {
      title: '查看状态',
      scrollToTop: true,
      keepAlive: true,
      transition: false,
    },
    component: state
  },
]

const router = new Router({
  //mode: 'history',
  //base:'/sg/',
  routes : routes
})

const commit = store.commit || store.dispatch;
// 处理 路由切换效果
var history = window.sessionStorage;
history.clear();
var historyCount = history.getItem('count') * 1 || 0;
history.setItem('/', 0);
// var $self = this;

router.beforeEach((to, from, next) => {
  const toIndex = history.getItem(to.name);
  const fromIndex = history.getItem(from.name);
  // 处理 路由切换效果
  if (from.name != null) {
    if (toIndex) {
      if (toIndex > fromIndex) {
        commit(types.UPDATE_DIRECTION, 'forward');
      } else {
        commit(types.UPDATE_DIRECTION, 'reverse');
      }
    } else {
      ++historyCount;
      history.setItem('count', historyCount);
      to.name !== '/' && history.setItem(to.name, historyCount);
      commit(types.UPDATE_DIRECTION, 'forward');
    }
  } else {
    if (toIndex) {
      if (toIndex > fromIndex) {
        commit(types.UPDATE_DIRECTION, 'forward');
      } else {
        commit(types.UPDATE_DIRECTION, 'reverse');
      }
    } else {
      ++historyCount;
      history.setItem('count', historyCount);
      to.name !== '/' && history.setItem(to.name, historyCount);
      commit(types.UPDATE_DIRECTION, 'forward');
    }
  }
  // 国际化 放在APP.vue中处理
  // document.title = to.meta.title
  commit(types.UPDATE_TITLE, to.meta.title)
  // loading
  // commit(types.UPDATE_LOADING, true)
  setTimeout(() => {
    commit(types.UPDATE_LOADING, true)
  }, 200)
  next();
})

router.afterEach(function (to) {
  setTimeout(() => {
    commit(types.UPDATE_LOADING, false)
  }, 500);

  try {
    // console.log('当前请求路由名称：', to.name)
    if (to.name === routerNames.OrderInvoiceDetail ||
      to.name === routerNames.InvoiceDetail
    ) {
      // location.replace(to.fullPath);
      // document.body.style['background-color'] = '#2b88d8';
      // document.getElementById('vux_view_box_body')
      // $('body').css({'background-color':'#2b88d8'});
    } else {
      // document.body.style['background-color'] = '#fbf9fe';
      // $('body').css({'background-color':'#fbf9fe'});
    }
  } catch (error) {

  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js